"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownListWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _popover = require("../../popover/popover.tokens");
var _input = require("../../../inputs/input/input.tokens");
var DropdownListWrapper = exports.DropdownListWrapper = _styledComponents.default.div.withConfig({
  displayName: "shared__DropdownListWrapper",
  componentId: "sc-zb2z9z-0"
})(["display:table-cell;background-color:white;", ";border-radius:", ";border:", ";width:", ";"], _popover.tokens.shadow, _popover.tokens.border.radius, _popover.tokens.border.default, function (_ref) {
  var width = _ref.width;
  return width ? width : _input.tokens.size.width.fixed;
});